/* eslint-disable unicorn/numeric-separators-style */

import { StoryData } from '@storyblok/react'
import { HomeStoryContent } from '../../types/home-story-content'

export const homeStoryFallback: StoryData<HomeStoryContent> = {
  name: 'Home',
  created_at: '2022-08-26T15:24:13.017Z',
  published_at: '2026-01-29T10:45:59.411Z',
  id: 181087593,
  uuid: 'e3977607-836f-42c1-b1cb-89b9d1aa2743',
  content: {
    usp: [
      {
        _uid: '35898337-35a6-4ea0-aa73-aa39b8a1f180',
        icon: 'CinchCareServicingIcon',
        link: {
          id: '',
          url: 'https://www.cinch.co.uk/car-care/servicing',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: 'https://www.cinch.co.uk/car-care/servicing',
        },
        text: 'Book a service or MOT at over 100 locations across the country - all cars welcome',
        title: 'Enjoy faff-free car servicing',
        component: 'HomeUspSlide',
      },
      {
        _uid: '83452c26-9b27-4f6d-a05f-7f6688b493c1',
        icon: 'SmartPhoneIcon',
        link: {
          id: '',
          url: '/app',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: '/app',
        },
        text: 'Browse, shortlist and compare cars, then buy your favourite in a tap and a swipe',
        title: 'Download our app',
        component: 'HomeUspSlide',
      },
      {
        _uid: 'f5ad17e6-c6ba-4c77-af3e-6691c48e9eb1',
        icon: 'SearchIcon',
        link: {
          id: '',
          url: 'https://www.cinch.co.uk/jaecoo',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: 'https://www.cinch.co.uk/jaecoo',
        },
        text: "Discover why everyone's talking about this modern, bold SUV",
        title: 'Explore the JAECOO 7',
        component: 'HomeUspSlide',
      },
    ],
    _uid: '97440a25-fa55-4494-b617-667b10e8b43c',
    herov2: [
      {
        _uid: '044581c6-7757-4826-8c3f-2ca374ee1abd',
        image: {
          id: 112364711600274,
          alt: 'test',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/132543/750x257/2a568d3fea/black-fri-website-750x257.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: { alt: 'test', title: '', source: '', copyright: '' },
          is_external_url: false,
        },
        heading: 'Daily deals',
        heroLink: [
          {
            _uid: '6f050fc2-c9c1-4903-94b1-3eadfbd66a9b',
            link: {
              id: '',
              url: '/new-cars/',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: '/new-cars/',
            },
            text: 'View cars on offer',
            component: 'LinkWithText',
          },
        ],
        component: 'HomeHeroV2',
        subheading: '£250-£1000 off selected cars, with a free 90-day warranty',
        heroPartExchange: [
          {
            _uid: '3c08cc62-eff2-4c8e-97db-83b0cddf1719',
            label: 'Enter your car registration',
            title: 'Get a free, instant part exchange quote',
            ctaText: 'Start your free valuation',
            component: 'HeroV2PartExchange',
            placeholder: 'Eg. A20 FGG',
            partExTextList: [
              {
                _uid: '51f8a673-ee97-41d5-9d15-72c37f52105f',
                text: 'Guaranteed price for your car',
                component: 'Text',
              },
              {
                _uid: 'db718c63-d0c2-4db9-a6fd-d15541ab045e',
                text: 'No hidden fees',
                component: 'Text',
              },
              {
                _uid: 'b536bb75-35e5-41ef-a4fc-f1bd0a762546',
                text: 'We collect your part ex car',
                component: 'Text',
              },
            ],
          },
        ],
        rightSideContent: [
          {
            _uid: 'dc7c673a-00a3-4256-9639-b26804a3986a',
            slides: [
              {
                cta: [
                  {
                    url: 'used-cars?tags=cars-on-offer',
                    _uid: 'af7225d9-c112-45d0-a20b-5e19c0dcb5b9',
                    type: 'primary',
                    label: 'View cars on offer',
                    component: 'CtaButton',
                  },
                ],
                _uid: '531d3a45-f48a-433f-a2df-2e537cb55e0d',
                image: {
                  id: 138331293510756,
                  alt: "Neon 'Winter bargains' sign with two cinch cars either side",
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/600x250/8136e419a7/homepage-hero-winterbargains.webp',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: "Neon 'Winter bargains' sign with two cinch cars either side",
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: 'Winter bargains are\nhere!',
                component: 'HomeHeroCard',
                subheading: '£250-£1000 off over a thousand\nselected cars',
                campaignName: 'FY26 Q4 Winter Price reductions​',
              },
              {
                cta: [
                  {
                    url: '/car-care/servicing',
                    _uid: 'b056586f-3805-43dc-9f0c-77a4d8bb8008',
                    type: 'primary',
                    label: 'Book today',
                    component: 'CtaButton',
                  },
                ],
                _uid: '15b93220-25af-4942-af79-c0a068a9a955',
                image: {
                  id: 138322723871751,
                  alt: 'cinchServicing logo surrounded by neon servicing icons',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/600x250/748f4ffcb9/homepage-hero-cinchservicing.png',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'cinchServicing logo surrounded by neon servicing icons',
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: 'Faff-free servicing\nfrom £129.95',
                component: 'HomeHeroCard',
                subheading: 'Any make or model, at 100+ locations',
                campaignName: 'FY26 Q4 cinchServicing​',
              },
              {
                cta: [
                  {
                    url: 'new-cars/byd',
                    _uid: '063eb9e6-926b-44c6-936b-0b07403e4d19',
                    type: 'primary',
                    label: 'Buy a new BYD',
                    component: 'CtaButton',
                  },
                ],
                _uid: '4421879e-b34a-4774-b2d2-487effb34915',
                image: {
                  id: 138331293936741,
                  alt: 'BYD Sealion 7 in white with a green ring beneath',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/599x270/a3e5a10cc7/homepage-hero-bydwithring.webp',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'BYD Sealion 7 in white with a green ring beneath',
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: 'Brand new cars,\nnow on cinch',
                component: 'HomeHeroCard',
                subheading: 'Discover the future of electric motoring with BYD',
                campaignName: 'FY26 Q4 New cars BYD​',
              },
              {
                cta: [
                  {
                    url: 'used-cars?financeType=any\u0026sortingCriteria=11\u0026toPrice=200',
                    _uid: '354daf76-ed75-4722-92bc-9e90a335779a',
                    type: 'primary',
                    label: 'View cars',
                    component: 'CtaButton',
                  },
                ],
                _uid: 'c89a5d34-1ce4-4678-a73f-dc772ee74150',
                image: {
                  id: 138331293494371,
                  alt: 'Neon sign promoting cars under £199 per month',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/600x250/08508555e4/homepage-hero-199.webp',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'Neon sign promoting cars under £199 per month',
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: 'Faff-free deals',
                component: 'HomeHeroCard',
                subheading: '1000s of cars available \nunder £199 a month',
                campaignName: 'FY26 Q4 Winter 1000s of cars under £199',
              },
            ],
            component: 'LoopingCarousel',
            shouldLoop: true,
            slideSpeedInSeconds: '4',
          },
        ],
        isHeroPromotional: false,
        isMobileImageShown: true,
      },
    ],
    partEx: [
      {
        _uid: 'c000a459-55b0-4572-8d43-2aee50858d5a',
        link: 'Find out more about part exchange',
        image: {
          id: 5667847,
          alt: 'a customer smiling in their car',
          name: '',
          focus: null,
          title: '',
          filename:
            'https://a.storyblok.com/f/143588/598x478/f9bf0c0356/part-ex-valuation-image.png',
          copyright: '',
          fieldtype: 'asset',
        },
        label: 'Enter your car registration',
        title: 'Part exchange?',
        ctaText: 'Start your free valuation',
        subtitle: 'Get a free, instant part-ex quote.',
        component: 'PartExSection',
        placeholder: 'E.g. A20FGG',
      },
    ],
    whyCinch: [
      {
        _uid: '8f2aa82e-bddb-4f8b-bb8d-a82d218af4b9',
        cards: [
          {
            _uid: 'ecf148b3-c22a-43c0-a218-0838f9a9c65d',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: { textAlign: null },
                  content: [
                    {
                      text: 'With thousands of ',
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                    {
                      text: 'cars',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/used-cars',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        { type: 'styled', attrs: { class: '' } },
                      ],
                    },
                    {
                      text: ' all in one place, you’re sure to find your perfect one. All used cars come with a 90-day warranty and a minimum 6-month MOT for total peace of mind.',
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                  ],
                },
              ],
            },
            icon: 'vehicle-front',
            name: 'cars',
            title: 'Great value, high-quality used cars',
            component: 'WhyCinchCard',
          },
          {
            _uid: '805c8891-c1e1-4473-af1c-878283d7307a',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Buy outright or spread the cost with helpful ',
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                    {
                      text: 'finance',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/car-finance',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                        { type: 'styled', attrs: { class: '' } },
                      ],
                    },
                    {
                      text: ' options. You can ',
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                    {
                      text: 'part exchange',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/part-exchange',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        { type: 'styled', attrs: { class: '' } },
                      ],
                    },
                    {
                      text: ' and use the value of your old car to help pay for your new one.  ',
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                  ],
                },
              ],
            },
            icon: 'calculator',
            name: 'finance',
            title: 'Choose how you pay',
            component: 'WhyCinchCard',
          },
          {
            _uid: 'd66d275e-db99-409c-8668-ce859bd5b275',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: { textAlign: null },
                  content: [
                    {
                      text: 'Choose ',
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                    {
                      text: 'home delivery',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/delivery',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        { type: 'styled', attrs: { class: '' } },
                      ],
                    },
                    {
                      text: ' or ',
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                    {
                      text: 'collect',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/car-collections',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        { type: 'styled', attrs: { class: '' } },
                      ],
                    },
                    {
                      text: " from 100+ convenient locations to pick up your used car – it's up to you.",
                      type: 'text',
                      marks: [{ type: 'styled', attrs: { class: '' } }],
                    },
                  ],
                },
              ],
            },
            icon: 'home-delivery',
            name: 'delivery',
            title: 'Delivery or collection available',
            component: 'WhyCinchCard',
          },
        ],
        image: {
          id: 5776668,
          alt: 'Why cinch image',
          name: '',
          focus: null,
          title: '',
          filename:
            'https://a.storyblok.com/f/143588/2000x2268/41d124f34e/circle-rylan.png',
          copyright: '',
          fieldtype: 'asset',
        },
        title: 'Why cinch?',
        component: 'WhyCinchSection',
      },
    ],
    component: 'HomePage',
    carsCarousel: [
      {
        _uid: 'eae10720-b692-4ff4-85f5-1dc184d57001',
        title: 'Shop new cars',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '35000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: true,
        showOnlyCinchStock: false,
        financeRepresentativeExample: ['8f5a2e9b-c045-4e94-b6e5-8a413d3dca98'],
      },
    ],
    personalised: [
      {
        helpMeChoose: [
          {
            _uid: 'b492c62c-e9f6-4e94-b663-c953e7645897',
            body: 'Try our nifty Help Me Choose tool. Answer a few quick questions to find your perfect match.',
            image: {
              id: 6870271,
              alt: 'multiple cars',
              name: '',
              focus: null,
              title: '',
              filename:
                'https://a.storyblok.com/f/143588/2220x1440/eddc06cce0/help-me-choose.png',
              copyright: '',
              fieldtype: 'asset',
            },
            title: 'Not sure what you are looking for?',
            ctaText: 'Help Me Choose',
            heading: 'Narrow down your search',
            component: 'HelpMeChooseSection',
          },
        ],
        valuePropositions: [
          {
            _uid: '29ef7655-a0f6-4c02-9235-7927b346b2a6',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    { text: 'All our used cars are ', type: 'text' },
                    {
                      text: 'carefully reconditioned',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/car-inspection',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                    {
                      text: ' and have at least six months’ MOT and come with a free 90-day warranty.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            icon: 'shield',
            heading: 'cinch quality assured for used cars',
            component: 'ValuePropsCard',
          },
          {
            _uid: 'cc8c6ebe-85c2-4124-a70e-ffff4f88cbb7',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Get protection for what matters to you with ',
                      type: 'text',
                    },
                    {
                      text: 'cinchCover.',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'http://www.cinch.co.uk/car-care/cinch-cover',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                    {
                      text: ' Keep your used car running and looking as it should, with protection against mechanical, electrical and cosmetic repairs.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            icon: 'shield-heart',
            heading: 'Caring for your used car',
            component: 'ValuePropsCard',
          },
        ],
      },
    ],
    newCarsCarouselTab: [
      {
        _uid: '09d1d678-d3e9-4c89-8e68-3623d2bbcc78',
        title: '',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '35000',
        component: 'CarsCarousel',
        priceFrom: '',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: true,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [
          {
            _uid: 'e9a24f21-cc71-4628-951a-bd4a691251d0',
            component: 'FinanceRepresentativeExample',
            creditAmount: '27863.92',
            onTheRoadPrice: '31723.92',
            customerDeposit: '2800',
            retailerDiscount: '1591.08',
            testDriveVoucher: '',
            representativeApr: '3.5',
            annualMileageLimit: '6000',
            totalAmountPayable: '34778',
            optionToPurchaseFee: '',
            totalInterestAmount: '3054.08',
            optionalFinalPayment: '15318',
            monthlyPaymentsAmount: '325',
            revisedOnTheRoadPrice: '',
            fixedAnnualInterestRate: '1.8',
            numberOfMonthlyPayments: '49',
            excessMileageChargeInPence: '14.9',
            financeDepositContribution: '1060',
          },
        ],
      },
    ],
    usedCarsCarouselTab: [
      {
        _uid: '5b7a9a83-da7c-4ae2-b126-c98e4c171b9b',
        title: '',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '20000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        disclaimer: '',
        carsCondition: 'used',
        showMonthlyPrices: false,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [],
      },
    ],
    previewPersonalisedContent: false,
  },
  slug: 'home',
  full_slug: 'home',
  sort_by_date: null,
  position: 60,
  tag_list: [],
  is_startpage: false,
  parent_id: 0,
  meta_data: null,
  group_id: '837246ae-690f-4e5c-9c54-002f7f2da6bf',
  first_published_at: '2022-08-26T15:28:52.094Z',
  lang: 'default',
  alternates: [],
}
